import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { cis2Api } from '../../app/apiPrescription';

export const cis2Slice = createSlice({
    name: 'cis2',
    initialState: {
        cis2rawData: null,
        idToken: null,
        token: null,
        expiresDate: null,
        refreshToken: null,
        refreshExpiresDate: null,
        nhsGpRole: null,
        _refresh: {
            timeoutId: null,
            abortController: null,
        },
    },
    reducers: {
        setCis2Authentication: (state, data) => {
            if (data.payload) {
                state.cis2rawData = { ...(state.cis2rawData || {}), ...data.payload };
                state.idToken = data.payload.token_summary.id_token;
                state.token = data.payload.token_summary.access_token;
                state.expiresDate = moment().add(data.payload.token_summary.expires_in, 'seconds');
                state.refreshToken = data.payload.token_summary.refresh_token;
                state.refreshExpiresDate = moment().add(data.payload.token_summary.refresh_token_expires_in, 'seconds');

                const GP_ROLE_CODE = 'R0260'; // General Medical Practitioner
                const gpRole = state.cis2rawData?.user?.nhsid_nrbac_roles?.find((role) => role.role_code?.endsWith(GP_ROLE_CODE));
                state.nhsGpRole = gpRole;

                console.info('cis2.setCis2Authentication', state.token);
            } else {
                clearRefreshTimeout(state);
                clearCis2Authentication(state);
            }
        },
        clearCis2Authentication: (state) => {
            state.cis2rawData = null;
            state.idToken = null;
            state.token = null;
            state.expiresDate = null;
            state.refreshToken = null;
            state.refreshExpiresDate = null;
            state.nhsGpRole = null;
        },
        setRefreshTimeout: (state, timeoutId) => {
            state._refresh.timeoutId = timeoutId.payload;
        },
        clearRefreshTimeout: (state) => {
            if (state._refresh.timeoutId) {
                clearTimeout(state._refresh.timeoutId);
                state._refresh.timeoutId = null;
            }
            clearRefreshAbortController(state);
        },
        setRefreshAbortController: (state, abortController) => {
            state._refresh.abortController = abortController.payload;
        },
        clearRefreshAbortController: (state) => {
            if (state._refresh.abortController) {
                state._refresh.abortController.abort();
                state._refresh.abortController = null;
            }
        },
    },
});
export const {
    setCis2Authentication,
    clearCis2Authentication,
    setRefreshTimeout,
    clearRefreshTimeout,
    setRefreshAbortController,
    clearRefreshAbortController,
} = cis2Slice.actions;

export const cis2token = (state) => state.cis2.token;
export const cis2idToken = (state) => state.cis2.idToken;
export const cis2User = (state) => state.cis2.cis2rawData?.user;
export const cis2nhsGpRole = (state) => state.cis2.nhsGpRole;
export const cis2gpCode = (state) => state.cis2.nhsGpRole?.org_code;

export const handleCis2Token = (data) => (dispatch, getState) => {
    dispatch(setCis2Authentication(data));
    if (getState().cis2.refreshToken && getState().cis2.refreshExpiresDate) {
        const tokenExpiresIn = getState().cis2.cis2rawData.token_summary.expires_in;
        // const tokenExpiresIn = 10;

        const timeoutHandlerId = setTimeout(
            () => {
                dispatch(clearRefreshTimeout());

                const abortController = new AbortController();
                dispatch(setRefreshAbortController(abortController));

                cis2Api
                    .refreshToken({ refreshToken: getState().cis2.refreshToken, signal: abortController.signal })
                    .then((res) => {
                        console.info('cis2.refreshToken success');
                        dispatch(handleCis2Token(res));
                    })
                    .catch((error) => {
                        console.error('cis2.refreshToken', error);
                    });
            },
            // (tokenExpiresIn * 1000) / 2,
            (tokenExpiresIn * 1000) / 1.2,
        );
        dispatch(clearRefreshTimeout());
        dispatch(setRefreshTimeout(timeoutHandlerId));
    }
};

export default cis2Slice.reducer;
